import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBuilding = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M22 20a1 1 0 0 1 .117 1.993L22 22H2a1 1 0 0 1-.117-1.993L2 20h20Z" />
      <path d="M9 10H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-4 2h4v8H5v-8Z" />
      <path d="M19 1h-8a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-8 2h8v17h-8V3Z" />
      <path d="M16 15.004a1 1 0 0 1 .117 1.993l-.117.007h-2a1 1 0 0 1-.117-1.993l.117-.007h2ZM8 15.004a1 1 0 0 1 .117 1.993L8 17.004H6a1 1 0 0 1-.117-1.993L6 15.004h2ZM16 10.504a1 1 0 0 1 .117 1.993l-.117.007h-2a1 1 0 0 1-.117-1.993l.117-.007h2ZM16 6.004a1 1 0 0 1 .117 1.993L16 8.004h-2a1 1 0 0 1-.117-1.993L14 6.004h2Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgBuilding)
const Memo = memo(ForwardRef)
export default Memo
